import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { IconAward, IconTool, IconUsers, IconCheckCircle } from '../components/Icons';
import './Home.css';

/* ── Datos ──────────────────────────────────────────── */
const WHY_US = [
  {
    n: '01', Icon: IconAward, title: 'Experiencia comprobada',
    desc: 'Más de 10 años ejecutando proyectos mineros y ambientales en Colombia.'
  },
  {
    n: '02', Icon: IconTool, title: 'Rigor técnico',
    desc: 'Metodologías actualizadas conforme a normativa nacional e internacional vigente.'
  },
  {
    n: '03', Icon: IconUsers, title: 'Acompañamiento integral',
    desc: 'Presentes desde la conceptualización hasta la ejecución y seguimiento.'
  },
  {
    n: '04', Icon: IconCheckCircle, title: 'Enfoque sostenible',
    desc: 'Responsabilidad ambiental integrada en cada solución técnica que diseñamos.'
  },
];

/* ── Componente ─────────────────────────────────────── */
export default function Home() {
  const [heroVisible, setHeroVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setHeroVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  /* IntersectionObserver para animaciones de entrada */
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('in-view'); obs.unobserve(e.target); }
      }),
      { threshold: 0.12 }
    );
    document.querySelectorAll('.reveal').forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div className="home">

      {/* ══════════ HERO ══════════ */}
      <section className={`hero${heroVisible ? ' hero--on' : ''}`}>
        <div className="hero__bg" />
        <div className="hero__grid-overlay" aria-hidden="true" />
        <div className="container hero__layout">

          <div className="hero__text">
            <div className="hero__badge">Consultoría Minera y Ambiental</div>
            <h1 className="hero__title">
              Soluciones Técnicas para la{' '}
              <span className="hero__hl">Minería Sostenible</span>
            </h1>
            <p className="hero__sub">
              Impacta M.A. SAS brinda asesoría integral en planes de ventilación,
              sostenimiento, gestión ambiental y cumplimiento normativo para el sector
              minero colombiano.
            </p>
            <div className="hero__btns">
              <Link to="/servicios/mineria" className="btn btn--primary btn--lg">Ver Servicios Mineros</Link>
              <Link to="/servicios/ambiental" className="btn btn--ghost-white btn--lg">Ver Servicios Ambientales</Link>
              <Link to="/contacto" className="btn btn--blue btn--lg">Solicitar Cotización</Link>
            </div>
          </div>

          <div className="hero__logo-col">
            <div className="hero__logo-glow" />
            <div className="hero__logo-wrap">
              <picture>
                <source srcSet="/logo3.webp" type="image/webp" />
                <img src="/logo3.webp" alt="Impacta M.A. SAS" className="hero__logo-img" />
              </picture>
              <div className="hero__values">
                <span>Responsabilidad</span><span className="hero__sep">·</span>
                <span>Compromiso</span><span className="hero__sep">·</span>
                <span>Profesionalismo</span>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* ══════════ POR QUÉ ELEGIRNOS ══════════ */}
      <section className="why-section">
        <div className="container">
          <div className="why-header">
            <h2 className="section-title">¿Por qué elegir Impacta M.A.?</h2>
            <p className="section-lead">
              Un equipo especializado con más de una década de experiencia en el sector
              minero y ambiental colombiano.
            </p>
          </div>

          <div className="why-grid">
            {WHY_US.map((w, i) => (
              <div
                className="why-card"
                key={w.title}
              >
                <div className="why-card__header">
                  <div className="why-card__icon-bg"><w.Icon size={26} /></div>
                  <span className="why-card__n">{w.n}</span>
                </div>
                <h3 className="why-card__title">{w.title}</h3>
                <p className="why-card__desc">{w.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════ CTA ══════════ */}
      <section className="cta-section">
        <div className="cta-section__bg" />
        <div className="container cta-section__inner">
          <div className="cta-section__text">
            <h2>¿Listo para comenzar su proyecto?</h2>
            <p>
              Contáctenos y un especialista le orientará sobre la mejor solución para
              sus necesidades específicas.
            </p>
          </div>
          <div className="cta-section__btns">
            <Link to="/contacto" className="btn btn--primary btn--lg">Solicitar Asesoría</Link>
          </div>
        </div>
      </section>

    </div>
  );
}
